import {Injectable} from '@angular/core';
import {AppState} from '../store';
import {select, Store} from '@ngrx/store';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {isAnyAdmin, isUserProfileLoaded, selectTenantInfo, selectUser, selectUserPermissions} from '../store/selectors';
import {catchError, filter, map, tap} from 'rxjs/operators';
import {combineLatest, from, Observable} from 'rxjs';
import {isUserAllowedInCommunity, isUserAllowedInRoom} from './utils';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CommunityPostsService} from './services/community-posts.service';


@Injectable({
    providedIn: 'root'
})
export class CommunityAccessGuard  {

  message = 'You do not have access to this community room yet';

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private snackbar: MatSnackBar) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean| UrlTree> {

    return combineLatest([
      this.store.pipe(select(selectUser)),
      this.store.pipe(select(selectTenantInfo)),
      this.store.pipe(select(isAnyAdmin)),
      this.store.pipe(select(isUserProfileLoaded)),
    ])
      .pipe(
        catchError(err => {
          console.log('an error occurred', err);
          return null;
        }),
        // wait for the user profile to be loaded before deciding to give access to the community
        filter(([user, tenantInfo, isAnyAdmin, isUserProfileLoaded]) => {
          return isUserProfileLoaded;
        }),
        map(([user, tenantInfo, isAnyAdmin, isUserProfileLoaded]) => {

          const currentUser = user;
          const isAdmin = isAnyAdmin;
          const communitySettings = tenantInfo.communitySettings;

          console.log(`COMMUNITY currentUser: `, currentUser);

          // if (!communitySettings?.enabled) {
          //   return this.router.parseUrl('/courses');
          // }

          const isAllowed = isUserAllowedInCommunity(communitySettings, isAdmin, currentUser);

          if (!isAllowed) {
            this.message = currentUser.id == 'anonymous' ? this.message = 'You must be logged in to access this community room' : this.message;

            this.snackbar.open(this.message, 'OK', {
              duration: 3000
            });
            console.log('user not allowed in this route...')

            return this.router.parseUrl('/community/home');
          }

          return true;
        }),

      );
  }
}
